(() => {
  if (window.__gowinPdpRewardDedupeV1) return;
  window.__gowinPdpRewardDedupeV1 = true;

  const productSelector = 'product-info[id^="MainProduct-"]';
  const ownRewardSelector = '[data-gowin-product-reward]';
  const hiddenAttribute = 'data-gowin-koin-reward-hidden';
  let frame = 0;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const isDuplicateRewardCopy = (value) => {
    const text = normalize(value);
    return text.includes('recibe') && text.includes('recompensas') && text.includes('gowin');
  };

  const identity = (node) => [
    node.id || '',
    typeof node.className === 'string' ? node.className : '',
    node.getAttribute?.('data-block-id') || '',
    node.getAttribute?.('data-app-block') || ''
  ].join(' ').toLowerCase();

  const hide = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(ownRewardSelector) || node.querySelector(ownRewardSelector)) return;
    node.setAttribute(hiddenAttribute, 'true');
    node.style.setProperty('display', 'none', 'important');
  };

  const findDuplicateContainer = (start) => {
    let node = start;
    let fallback = null;

    for (let depth = 0; node && depth < 8; depth += 1, node = node.parentElement) {
      if (!(node instanceof Element)) break;
      if (node.matches(ownRewardSelector) || node.querySelector(ownRewardSelector)) return null;

      const text = normalize(node.textContent);
      const markedAsKoin = identity(node).includes('koin');

      if (markedAsKoin && node !== document.body && node !== document.documentElement) return node;

      if (
        node.matches('div, section, aside, article, shopify-app-block') &&
        isDuplicateRewardCopy(text) &&
        text.length <= 260 &&
        !node.querySelector('.product-form__submit')
      ) {
        fallback = node;
      }

      if (node.matches(productSelector)) break;
    }

    return fallback;
  };

  const scan = () => {
    const productInfo = document.querySelector(productSelector);
    if (!productInfo) return;
    const productSection = productInfo.closest('.shopify-section') || productInfo.parentElement || productInfo;

    productInfo.querySelectorAll('[id*="koin" i], [class*="koin" i]').forEach((node) => {
      if (node.closest(ownRewardSelector)) return;
      const text = normalize(node.textContent);
      if (isDuplicateRewardCopy(text) || node.querySelector('iframe')) hide(node);
    });

    productSection.querySelectorAll('div, section, aside, article, shopify-app-block, p').forEach((node) => {
      if (!isDuplicateRewardCopy(node.textContent)) return;
      const container = findDuplicateContainer(node);
      if (container) hide(container);
    });
  };

  const scheduleScan = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      scan();
    });
  };

  const start = () => {
    scan();

    if (!document.body) return;
    const observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    window.setTimeout(scan, 250);
    window.setTimeout(scan, 900);
    window.setTimeout(scan, 1800);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('pageshow', scheduleScan);
})();
